// Updated AdminPanel.js - Add this import and case
import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import Dashboard from './pages/Dashboard';
import Policies from './pages/Policies';
import API from './pages/API';
import Products from './pages/Products';
import Categories from './pages/Categories';
import Orders from './pages/Orders';

import BasicInformation from './pages/BasicInformation';
import Site from './pages/Site'; // ADD THIS IMPORT
import Footer from './pages/Footer';
import Customers from './pages/Customers';
import OfferManagement from './pages/OfferManagement';

const AdminPanel = ({ authToken, onLogout }) => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  

  const renderContent = () => {
    switch(activeTab) {
      case 'dashboard':
        return <Dashboard authToken={authToken} setActiveTab={setActiveTab} />;
      case 'basic-info':
        return <BasicInformation authToken={authToken} />;
      case 'site': // ADD THIS CASE
        return <Site authToken={authToken} />;
      case 'footer':
        return <Footer authToken={authToken} />;
      case 'policies':
        return <Policies authToken={authToken} />;
      case 'api':
        return <API authToken={authToken} />;
      case 'products':
        return <Products authToken={authToken} />;
      case 'categories':
        return <Categories authToken={authToken} />;
      case 'orders':
        return <Orders authToken={authToken} />;
      case 'customers':
        return <Customers authToken={authToken} />;
      case 'offer-management':
        return <OfferManagement authToken={authToken} />;
      default:
        return <Dashboard authToken={authToken} />;
    }
  };

  return (
    <div className="h-screen bg-gray-50 flex overflow-hidden">
      <Sidebar 
        activeTab={activeTab} 
        setActiveTab={setActiveTab}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      />
      
      <div className="flex-1 flex flex-col min-w-0">
        <Header 
          activeTab={activeTab}
          setSidebarOpen={setSidebarOpen}
          onLogout={onLogout}
        />
        
        <main className="flex-1 p-6 overflow-y-auto">
          {renderContent()}
        </main>
      </div>
    </div>
  );
};

export default AdminPanel;  